import React from 'react';
import { TextFieldFormComponent } from '@/formbuilder/TextFieldFormComponent.atom';
import { getFormFieldWrapperProps } from '@/formbuilder/formbuilder.utilities';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface FormControlJsonIF extends ValidatingFormComponent<string | number> {
  component: 'JsonTextAreaFormComponent';
  placeholder?: string;
  onBlur?: (value: string) => void;
  type?: string;
  step?: number;
  size: 'sm' | 'lg';
  rows?: number;
  value: string;
  disabled?: boolean;
}

export const JsonTextAreaFormComponent = (props: FormControlJsonIF) => {
  const {
    name,
    extendValidation,
    validation,
    placeholder,
    onChange,
    onBlur,
    customErrorText,
    step,
    size,
    rows,
    value,
    disabled,
    extraClassNames = '',
  } = props;

  const specialError = React.useRef<string | null>(null);
  const jsonValidation = (value: string | number | undefined) => {
    try {
      JSON.parse(String(value ?? ''));
    } catch (e) {
      specialError.current = String(e);
      return true;
    }
    return false;
  };

  const jsonCustomError = (): string | undefined =>
    customErrorText !== null && customErrorText !== undefined ? customErrorText : (specialError.current ?? undefined);

  return (
    <TextFieldFormComponent
      component="TextFieldFormComponent"
      {...getFormFieldWrapperProps(props)}
      name={name}
      extendValidation={extendValidation}
      validation={(value: string | number) => {
        if (validation !== null && validation !== undefined) {
          return validation(value);
        }
        return jsonValidation(value);
      }}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      type="text"
      step={step}
      size={size}
      rows={rows}
      value={value}
      as="textarea"
      disabled={disabled}
      customErrorText={jsonCustomError()}
      extraClassNames={`text-monospace ${extraClassNames}`}
    />
  );
};
